import { useQueryClient } from '@tanstack/react-query';

import { useCommunityActionBase } from './useCommunityActionBase';
import { invalidateCommunityFeedQueries } from './useCommunityFeedActionMutation';
import { SCHEDULED_POSTS_QUERY_KEY } from './useCommunityScheduledPosts';

// The published post joins the feed. A refused publish reloads the queue too, which shows a post that couldn't publish
// and drops one that started publishing after the queue loaded.
const usePublishCommunityScheduledPostMutation = () => {
  const queryClient = useQueryClient();

  return useCommunityActionBase<string>({
    buildRequest: (scheduledPostId) => ({
      path: '/publish_community_scheduled_post',
      fields: { scheduled_post_id: scheduledPostId },
    }),
    onSuccess: () => invalidateCommunityFeedQueries(queryClient),
    onSettled: () => queryClient.invalidateQueries({ queryKey: SCHEDULED_POSTS_QUERY_KEY }),
  });
};

export default usePublishCommunityScheduledPostMutation;
